import { IRIS } from './component-iris';
import { reactForceAllUpdate } from './component-react';
export const svrtsRequest = (obj) => {
    IRIS.Send({
        data: {
            ...obj.data,
            forceTS: true,
            progID: obj.data.funcID[0],
            funcID: obj.data.funcID[1],
        },
        yes: data => {
            obj.yes(data);
            if (obj.forceUpdate !== false) {
                reactForceAllUpdate();
            }
        },
        no: data => {
            if (obj.no) {
                obj.no(data);
                return;
            }
            console.error('No `no` handler: ', data);
        },
        any: obj.any,
        prog: obj.prog,
    });
};
//# sourceMappingURL=svrts-interface.js.map